///include /assets/js/app/s/catalogue.js
///include /assets/js/app/p/spayment-item.js
///include /assets/js/app/s/basket.js
///include /assets/js/app/p/bs-contact.js
///include /assets/js/app/p/brand.js

class SOrderSslPage {
    init() {
        this.view = new Vue({
            el: ".vue-wrapper",
            name: "order-ssl",
            data: {
                /** @type {SBasket} */
                //@ts-ignore
                basket: AnyBasket.inst,
                brand: null,
                catalogue: UserCatalogue.inst,
                /** @type {?BSContact} */
                contact: null,
                format: Site.Format,
                hasQuery: false,
                /** @type {?GET.Services.service.output} */
                packages: null,
                selectedDomainOption: null,
                /**
                 * @type {?GET.Stack.Catalogue.$ns.catalogue._design.product._view.byType.output}
                 */
                productsAvailableByType: null,
                productDescriptions: null,
                selectedDomain: null,
                selectedSsl: null,
                settings: SharedSettings.inst,
                ssl: {
                    authType: "email",
                    /** @type {SPaymentItem["type"]} */
                    //@ts-ignore
                    payment_type: "card",
                    selected_domain: {
                        name: null,
                        subpart: null,
                    },
                    type: "simple",
                },

                get wildcardMajorPrice() {
                    var sslProduct = this.sslProducts.find( p => p.type =='tucows-rapidssl_wildcard' );
                    if(!sslProduct) return "";
                    return Site.Format.priceMajor(
                        sslProduct.lowestPrice.price,
                        this.catalogue.currency
                    );
                },

                get wildcardMinorPrice() {
                    var sslProduct = this.sslProducts.find( p => p.type =='tucows-rapidssl_wildcard' );
                    if(!sslProduct) return "";
                    return Site.Format.priceTail(
                        sslProduct.lowestPrice.price,
                        this.catalogue.currency
                    );
                },

                get extendedMajorPrice() {
                    var sslProduct = this.sslProducts.find( p => p.type =='tucows-truebizid_ev' );
                    if(!sslProduct) return "";
                    return Site.Format.priceMajor(
                        sslProduct.lowestPrice.price,
                        this.catalogue.currency
                    );
                },

                get extendedMinorPrice() {
                    var sslProduct = this.sslProducts.find( p => p.type =='tucows-truebizid_ev' );
                    if(!sslProduct) return "";
                    return Site.Format.priceTail(
                        sslProduct.lowestPrice.price,
                        this.catalogue.currency
                    );
                },

                get simpleMajorPrice() {
                    var sslProduct = this.sslProducts.find( p => p.type =='tucows-rapidssl' );
                    if(!sslProduct) return "";
                    return Site.Format.priceMajor(
                        sslProduct.lowestPrice.price,
                        this.catalogue.currency
                    );
                },

                get simpleMinorPrice() {
                    var sslProduct = this.sslProducts.find( p => p.type =='tucows-rapidssl' );
                    if(!sslProduct) return "";
                    return Site.Format.priceTail(
                        sslProduct.lowestPrice.price,
                        this.catalogue.currency
                    );
                },

                get has() {
                    /** @type {{[x: string]: boolean}} */
                    const out = {}
                    const pat = this.productsAvailableByType
                    if(pat && pat.tls_certificate) {
                        if(pat.tls_certificate["tucows-rapidssl"]) {
                            const simpleProduct = this.products.find(p => p.type === "tucows-rapidssl")
                            out.simple = simpleProduct && !simpleProduct.hidden
                        }
                        if(pat.tls_certificate["tucows-truebizid_ev"]) {
                            const extendedProduct = this.products.find(p => p.type === "tucows-truebizid_ev")
                            out.extended = extendedProduct && !extendedProduct.hidden
                        }
                        if(pat.tls_certificate["tucows-rapidssl_wildcard"]) {
                            const wildcardProduct = this.products.find(p => p.type === "tucows-rapidssl_wildcard")
                            out.wildcard = wildcardProduct && !wildcardProduct.hidden
                        }
                    }
                    return out
                },
                get loading() {
                    return !(
                        this.sslProducts && this.sslProducts.length
                    );
                },
                get pageQuery() {
                    const query = window.location.search.substr(1).split('&')

                    if (!query) return null

                    /**
                     * @type {{ type: string, code: string }}
                     */
                    const queryObj = query.reduce((result, q) => {
                        const qParts = q.split('=')
                        result[qParts[0]] = qParts[1]
                        return result
                    }, {})

                    return { query, queryObj }
                },
                get products() {
                    if(this.catalogue.products) {
                        return this.catalogue.products.filter(
                            p => p.forSale
                        )
                    } else {
                        return []
                    }
                },
                /** @type {SBTLSCertificateProduct[]} */
                get sslProducts() {
                    //@ts-ignore
                    return this.products.filter(
                        p => p.codePrefix == "tls_certificate"
                    )
                },
                get typeToRealCode() {
                    switch(this.ssl.type) {
                        case "simple":
                            return "tucows-rapidssl"
                        case "extended":
                            //nope//return "globalsign-extendedssl"
                            return "tucows-truebizid_ev"
                        case 'wildcard':
                            return "tucows-rapidssl_wildcard";
                        default:
                            return null
                    }
                },
                customDescription(code) {
                    var type;
                    switch(code) {
                        case 'simple':
                            type = "tls_certificate:tucows-rapidssl";
                            break;
                        case 'extended':
                            type = "tls_certificate:tucows-truebizid_ev";
                            break;
                        case 'wildcard':
                            type = "tls_certificate:tucows-rapidssl_wildcard";
                            break;
                    }
                    if( this.productDescriptions && this.productDescriptions[type] && this.productDescriptions[type].length > 0 ){
                        return this.productDescriptions[type][0].content;
                    } else {
                        return null;
                    }
                }
            },
            computed: {
                verificationMethods() {
                    if(this.ssl.type === "simple") return ["email", "dns", "file"]
                    if(this.ssl.type === "wildcard") return ["email", "dns"]
                    return ["email"]
                },
                isDisabled() {
                    const hasCountry = !!(this.contact && this.contact.eppContact.postalInfo.addr.cc)
                    const hasState = !!(this.contact && this.contact.sp)

                    const name = this.ssl.selected_domain && this.ssl.selected_domain.name
                    const hasDomainName = !!(name && name.match(/^([a-z0-9]+(-[a-z0-9]+)*[.])+[a-z]{2,}$/))

                    const subpart = this.ssl.selected_domain && this.ssl.selected_domain.subpart
                    const hasSubDomainName = subpart ? !this.subdomainCheck : true

                    return !(hasState && hasCountry && hasDomainName && hasSubDomainName)
                },
                subdomainCheck() {
                    const subpart = this.ssl.selected_domain.subpart
                    if (!subpart) return false
                    return subpart.match(/[,\/#!$%\^&\*;:{}=`~()]/g) || subpart.match(/\s/g) || subpart.match(/\.$/g)
                },
                sslAllowedDomainsOptions() {
                    if(!this.packages) return null
                    const package_options = this.packages.map( p => ({
                        text: p.name,
                        id: p.name,
                    }))
                    if(this.basket && this.basket.itemsFlat) {
                        return package_options.concat(
                            this.basket.itemsFlat.filter(
                                bi => bi.serviceType == "package"
                            ).map(p => ({
                                text: p.name,
                                id: p.name
                            }))
                        )
                    } else {
                        return package_options
                    }
                },
            },
            watch: {
                "ssl.type": function() {
                    if(!this.verificationMethods.includes(this.ssl.authType)) {
                        this.ssl.authType = "email"
                    }
                },
                selectedDomainOption(v) {
                    this.ssl.selected_domain.name = v || null
                },
                loading(v) {
                    if(!v) {
                        Vue.nextTick( () => {
                            $( ".page-loaded-content" ).fadeTo(200,1, function() {});
                        });
                    }
                },
                "settings.contact": function(n) {
                    if(n && n.email) {
                        this.contact = new BSContact({
                            postalInfo: {
                                name: n.person_name,
                                org: null,
                                addr: {
                                    street: n.address.split("\n"),
                                    city: n.city,
                                    sp: n.sp,
                                    pc: n.pc,
                                    cc: "",
                                },
                            },
                            voice: n.voice,
                            email: n.email,
                            extension: {},
                        })
                    } else {
                        this.contact = new BSContact({
                            postalInfo: {
                                name: "",
                                org: null,
                                addr: {
                                    street: ["",""],
                                    city: "",
                                    sp: "",
                                    pc: "",
                                    cc: "",
                                },
                            },
                            voice: "",
                            email: "",
                            extension: {},
                        })
                    }
                }
            },
            methods: {
                async add_ssl_to_basket() {
                    // This is a wrapper to the real addSslToBasket
                    // function, here we are going to find the exact
                    // product and price and send on to the function
                    // that will actually to the add ssl to basket
                    // part.
                    if(
                        this.ssl.selected_domain.name &&
                        this.ssl.selected_domain.subpart &&
                        this.typeToRealCode
                    ) {

                        if( this.ssl.type == 'extended' && (!this.contact.eppContact || !this.contact.eppContact.extension || !this.contact.eppContact.extension.type || this.contact.eppContact.extension.type == 'IND') ){
                            ShowNotification.fail("A business/organisation contact is required for the extended SSL");
                            return false;
                        }

                        const products = this.sslProducts.filter(
                            p => p.type == this.typeToRealCode
                        )
                        if(!products.length) {
                            throw new Error(
                                `No products match ${this.typeToRealCode}`
                            )
                        }
                        if(products.length) {
                            const product = products[0]
                            // Get the price.
                            const prices = product.pricing.filter(
                                p => p.matchesPaymentType(this.ssl.payment_type)
                            )
                            if(!prices.length) {
                                throw new Error(
                                    `No prices match ${this.ssl.payment_type}`
                                )
                            }
                            await this.catalogue.preload([
                                "config",
                                "userVATRate"
                            ])
                            const cn =
                                `${this.ssl.selected_domain.subpart}.${this.ssl.selected_domain.name}`
                            const pic = PaymentItemCollection.inst
                            await this.basket.addWithInfo(
                                {
                                    paymentItemCountries:
                                        await pic.preloadSingle("countriesFlat"),
                                },
                                await product.basketItem(
                                    prices[0],
                                    null,
                                    1,
                                    {
                                        authType: this.ssl.authType,
                                        approveEmail: `admin@${this.ssl.selected_domain.name}`,
                                        domain: cn,
                                        contact: this.contact,
                                    }
                                )
                            )
                            window.location.href="/checkout";
                        }
                    } else {
                        ShowNotification.fail(
                            `Please complete your domain details.`
                        )
                    }
                },
            },

            components: {
                shopNav: ShopNav,
                vueSelect: VueSelect,
            },

            async mounted() {
                await this.catalogue.assertExists()
                const [byType, productDescriptions] = await Promise.all([
                    $.ajax(`/a/catalogue/_design/product/_view/byType`),
                    $.ajax(`/a/catalogue/productDescription`).catch(e => { console.error(e); return null; })
                ])
                this.productsAvailableByType = byType
                this.productDescriptions = productDescriptions

                if (this.pageQuery && this.pageQuery.queryObj.code) {
                    this.hasQuery = true
                    const code = this.pageQuery.queryObj.code.split(':')[1]
                    const pat = this.productsAvailableByType

                    if (pat && pat.tls_certificate && pat.tls_certificate[code]) {
                        if (code === "tucows-rapidssl") {
                            this.ssl.type = 'simple'
                        }
                        if (code === "tucows-truebizid_ev") {
                            this.ssl.type = 'extended'
                        }
                        if (code === "tucows-rapidssl_wildcard") {
                            this.ssl.type = 'wildcard'
                        }
                    }
                } else {
                    const preferredOrder = ['simple', 'extended', 'wildcard']
                    const firstAvailable = preferredOrder.find(t => this.has[t])
                    if (firstAvailable) {
                        this.ssl.type = firstAvailable
                    }
                }

                /** @type {GET.Services.service.output} */
                this.packages = await $.ajax(`/o/package?purpose=web`)
                    .catch(e => { console.error(e); return []; })
            },
        })
    }
}
